//引入外部模組
import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import {LinkEffect} from './link_effect';
import {LightboxMap} from './map';
import {Mortgage, PersonalForm, RealtyForm} from './form';
import {SendForm} from './other';




//Lightbox
class Lightbox {
  constructor() {
    this.img            = $('a[data-type="image"]');
    this.objForm        = $('a.formLightbox');
    this.mortgageForm   = $('a.mortgageLightbox');
    this.objMap         = $('a.mapLightbox');
    this.webQRcode      = $('button.qrcodeWeb');
    this.objQRcode      = $('button.qrcodeRealty');
    this.openVideo      = $('a#openVideo');
    this.personalInfo   = $('button.personalInfo, a.personalInfo');
    this.personalForm   = $('a.personalLightbox');
    this.personalQRcode = $('button.qrcodePersonal');
  }
  image() {
    this.img.fancybox({
      loop   : true,
      protect: true,
      buttons: ['zoom', 'slideShow', 'fullScreen', 'close']
    });
  }
  map() {
    this.objMap.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false,
      afterLoad: () => {
        //For AJAX
        let map = new LightboxMap;
        map.mapAPI(); //Google Maps
      }
    });
  }
  form() {
    this.objForm.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false,
      afterLoad: () => {
        //For AJAX
        let linkEffect = new LinkEffect;
        let realtyForm = new RealtyForm;
        let sendForm   = new SendForm;
        linkEffect.effect();    //頁面淡入淡出
        realtyForm.checkForm(); //Lightbox - 預約看屋 & 降價通知 & 買屋留言
        sendForm.realtyForm();  //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
      }
    });
    this.mortgageForm.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false, 
      afterLoad: () => {
        //For AJAX
        let mortgage = new Mortgage;
        mortgage.resultMortgage(); //Lightbox - 房貸試算
      }
    });
    this.personalForm.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false,
      afterLoad: () => {
        //For AJAX
        let linkEffect   = new LinkEffect;
        let personalForm = new PersonalForm;
        let sendForm     = new SendForm;
        linkEffect.effect();      //頁面淡入淡出
        personalForm.checkForm(); //Lightbox - 業務個人
        sendForm.personalForm();  //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
      }
    });
  }
  qrcode() {
    this.webQRcode.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false
    });
    this.objQRcode.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false
    });
    this.personalQRcode.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false
    });
  }
  video() {
    this.openVideo.fancybox({
      buttons : ['close'],
      smallBtn: false,
      touch   : false
    });
  }
  personal() {
    this.personalInfo.fancybox({
      toolbar : false,
      smallBtn: false,
      touch   : false
    });
  }
}




//輸出
export {Lightbox};


// WEBPACK FOOTER //
// ./js_new/lightbox.js